<h2 mat-dialog-title class="header">
  <mat-icon aria-hidden="true" color="warn">priority_high</mat-icon>
  <span class="subject">{{ data.subject }}</span>
</h2>

<div mat-dialog-content class="content" [innerHTML]="safeHtml"></div>

<div mat-dialog-actions align="end">
  <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial (click)="acknowledgeAlert()">
    Acknowledge
  </button>
</div>